<template>
        <div id="vuecropperbox">
             <div class="btnbox">
                <div class="imgbox">
                    <img :src="defaultimg" >
                    <div class="uplaodpross" v-if="is_procc_show">
                        <span class="jindu">
                            <i class="jindu_tiao" :class="{'jindu_red':is_upload_error}" :style="{width:pross_num}"></i>
                            <i class="jindu_num">{{ pross_num }}</i>
                        </span>
                        
                    </div>
                    <label :for="inputid"></label>
                    <input :id="inputid" type="file" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                </div>
             </div>
        </div>

        <div id="picbox" v-if="is_cut_show">
            <div class="box">
                 <div class="top">
                    <div class="title">图片剪切</div>
                 </div>
                 <div class="content">
                    <div class="cro_box">
                        <div class="cro">
                            <vue-cropper class="cropper"
                                ref="cropper"
                                :img="option.img"
                                :outputSize="option.outputSize"
                                :outputType="option.outputType"
                                :info="option.info"
                                :canScale="option.canScale"
                                :autoCrop="option.autoCrop"
                                :autoCropWidth="option.autoCropWidth"
                                :autoCropHeight="option.autoCropHeight"
                                :fixed="option.fixed"
                                :fixedNumber="option.fixedNumber"
                                :full="option.full"
                                :fixedBox="option.fixedBox"
                                :canMove="option.canMove"
                                :canMoveBox="option.canMoveBox"
                                :original="option.original"
                                :centerBox="option.centerBox"
                                :height="option.height"
                                :infoTrue="option.infoTrue"
                                :maxImgSize="option.maxImgSize"
                                :enlarge="option.enlarge"
                                :mode="option.mode"
                                @realTime="realTime"
                                @imgLoad="imgLoad">
                            </vue-cropper>
                            <div class="cro_btn">
                                <a class="fangda" @click="changeScale(1)">
                                    <img src="@/assets/fangda.png">
                                </a>
                                <a class="suoxiao" @click="changeScale(-1)">
                                    <img src="@/assets/suoxiao.png">
                                </a>
                            </div>
                        </div>
                        <div class="prcview_show">
                            <div :style="previews.div" class="preview">
                                <img :src="previews.url" :style="previews.img">
                            </div>
                        </div>
                        
                    </div>
                    
                 </div>
                 <div class="footer">
                    <a @click="closepic">取消</a>
                    <a @click="uploadImg('blob')">确认</a>
                 </div>
            </div>
        </div>

</template>

<script>
    import 'vue-cropper/next/dist/index.css'
    import {VueCropper} from 'vue-cropper/next'
    import http from '@/tools/Http';
    import { ElMessage} from 'element-plus';

    export default {
        name:"",
        components:{
            VueCropper
        },
        data(){
            return{
                previews: {},
                option:{
                    img: '',             //裁剪图片的地址
                    outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
                    outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
                    info: true,          //图片大小信息
                    canScale: true,      //图片是否允许滚轮缩放
                    autoCrop: true,      //是否默认生成截图框
                    autoCropWidth: 200,  //默认生成截图框宽度
                    autoCropHeight:200, //默认生成截图框高度
                    fixed: true,         //是否开启截图框宽高固定比例
                    fixedNumber: [1, 1], //截图框的宽高比例
                    full: true,         //false按原比例裁切图片，不失真
                    fixedBox: true,      //固定截图框大小，不允许改变
                    canMove: true,      //上传图片是否可以移动
                    canMoveBox: false,    //截图框能否拖动
                    original: true,     //上传图片按照原始比例渲染
                    centerBox: true,    //截图框是否被限制在图片里面
                    height: true,        //是否按照设备的dpr 输出等比例图片
                    infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
                    maxImgSize: 3000,    //限制图片最大宽度和高度
                    enlarge: 1,          //图片根据截图框输出比例倍数
                    mode: '50px 50px'    //图片默认渲染方式
                },
                defaultimg:require("@/assets/tianjia.png"),
                pross_num:"0%",
                is_cut_show:false,
                is_procc_show:false,
                is_upload_error:false,
                fileName:"",
                filePath:"",

            }
        },
        props:{
            modelValue:{
                // type: Array,
                type: String,
                default:""
            },
            inputid:{
                type:String,
                required:true
            }
        },
        async mounted(){
            if(this.modelValue.length>0){
                this.filePath=this.modelValue
            }
        },
        methods:{
                        //初始化函数
                imgLoad (msg) {
                },
                //图片缩放
                changeScale (num) {
                num = num || 1
                this.$refs.cropper.changeScale(num)
                },
                //向左旋转
                rotateLeft () {
                this.$refs.cropper.rotateLeft()
                },
                //向右旋转
                rotateRight () {
                this.$refs.cropper.rotateRight()
                },
                //实时预览函数
                realTime (data) {
                this.previews = data
                },
                //选择图片
                selectImg (e) {
                        if(e.target.files.length==0){
                            return
                        }
                        let file = e.target.files[0]
                        this.fileName=file.name
                        if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                            this.$message({
                            message: '图片类型要求：jpeg、jpg、png',
                            type: "error"
                            });
                            return false
                        }
                        //转化为blob
                        let reader = new FileReader()
                        reader.onload = (e) => {
                            let data
                            if (typeof e.target.result === 'object') {
                            data = window.URL.createObjectURL(new Blob([e.target.result]))
                            } else {
                            data = e.target.result
                            }
                            this.option.img = data
                            this.is_cut_show=true

                        }
                        //转化为base64
                        reader.readAsDataURL(file)
                },
                blobToFile(theBlob, fileName){
                    theBlob.lastModifiedDate = new Date();  // 文件最后的修改日期
                    theBlob.name = fileName;                // 文件名
                    return new File([theBlob], fileName, {type: theBlob.type, lastModified: Date.now()});
                },
                //上传图片
                uploadImg (type) {
                        let _this = this;
                        if (type === 'blob') {
                            //获取截图的blob数据
                            this.$refs.cropper.getCropBlob(async (data) => {
                            let file=this.blobToFile(data,this.fileName.substring(0,this.fileName.length-4)+'.png')
                            this.is_cut_show=false
                            this.defaultimg=await  this.getBase64(file)
                            this.is_procc_show=true
                            this.is_upload_error=false
                            this.pross_num="0%"
                            this.uploadfile(file)
                            })
                        }
                },
                uploadfile(file){
                        let formData=new FormData();
                        formData.append('file',file)

                        http.post('/file/uplaods',formData,{
                                headers:{
                                    'Content-Type':'multipart/form-data'
                                },
                                onUploadProgress:progressEvent=>{
                                   
                                    this.pross_num= Math.floor( (progressEvent.loaded/progressEvent.total)*100 )+"%"
                                }
                        }).then(res=>{
                            console.log(res)
                            if(res.status==0){
                                this.filePath=res.data
                                this.$emit('update:modelValue', this.filePath)

                            }else{
                                this.is_upload_error=true
                            }
                        }).catch(error=>{
                            console.log(error)
                            this.is_upload_error=true
                        })

                },
                getBase64(file) {
                    return new Promise(function (resolve, reject) {
                        let reader = new FileReader();
                        let imgResult = '';
                        reader.readAsDataURL(file);
                        reader.onload = function () {
                            imgResult = reader.result
                        };
                        reader.onerror = function (error) {
                            reject(error)
                        };
                        reader.onloadend = function () {
                            resolve(imgResult)
                        }
                    })
                },
                closepic(){
                    this.is_cut_show=false
                }

            }
    }
</script>
<style scoped>
    #vuecropperbox{
        width: 100%;
        height: 100%;
        float: left;
        border:1px solid #ccc;
        overflow: hidden;
    }
    #vuecropperbox .btnbox{
        width: 100%;
        height: 100%;
        float: left;
       
    }
    #vuecropperbox .btnbox .imgbox{
         position: relative;
         width: 100%;
         height: 100%;
         float: left;
    }
    #vuecropperbox .btnbox .imgbox img{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross{
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(0,0,0,.5);
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu{
        width: 100%;
        height: 30px;
        display: block;
        position: absolute;
        top: calc( 50% - 15px );
        background-color: rgba(0,0,0,.5);
        left: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_tiao{
        height: 30px;
        display: block;
        position: absolute;
        top: 0;
        background-color: rgba(11, 157, 8, 0.5);
        left: 0;
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_tiao.jindu_red{
        background-color: rgba(189, 21, 26, 0.5);
    }
    #vuecropperbox .btnbox .imgbox .uplaodpross .jindu .jindu_num{
        width: 100%;
        height: 30px;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        font-style: normal;
    }
    #vuecropperbox .btnbox .imgbox label{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
    }
    #vuecropperbox .btnbox .imgbox input{
        display: none;
    }

    #picbox{
        width: 100%;
        height: 100%;
        float: left;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.8);
    }
    #picbox .box{
        width: 650px;
        height: 400px;
        position: relative;
        left: 50%;
        top:50%;
        margin-left: -325px;
        margin-top: -200px;
        background-color: #fff;
        border-radius: 10px;
        padding:5px 10px;
    }
    #picbox .box .top{
        width: 100%;
        height: 40px;
        float: left;
        border-bottom:1px solid #ccc ;

    }
    #picbox .box .top .title{
        width: 100%;
        height: 100%;
        float: left;
        line-height: 40px;
        font-size: 16px;
    }
    #picbox .box .content{
        width: 100%;
        height: 300px;
        float: left;
        padding: 10px;
    }
    #picbox .box .content .cro_box{
        width: 100%;
        height: 100%;
        float: left;
    }
    #picbox .box .content .cro_box .cro{
        width: 400px;
        height: 260px;
        float: left;
    }
    #picbox .box .content .cro_box .cro .cropper{
        width: 350px;
        height: 220px;
        float: left;
        overflow: hidden;
    }
    #picbox .box .content .cro_box .cro .cro_btn{
        width: 100%;
        height: 40px;
        float: left;
        text-align: center;
    }
    #picbox .box .content .cro_box .cro .cro_btn a{
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-top: 5px;
        margin-right: 20px;
    }
    #picbox .box .content .cro_box .cro .cro_btn a img{
        width: 100%;
        height: 100%;
    }
    #picbox .box .content .cro_box .prcview_show{
        width: 200px;
        height: 200px;
        float: left;
        border: 1px solid #ccc;
        overflow: hidden;
        margin: 0 0;
    }
    #picbox .box .footer{
        width: 100%;
        height: 50px;
        float: left;
        text-align: center;
    }
    #picbox .box .footer a{
        width: 80px;
        height: 40px;
        display: inline-block;
        text-align: center;
        line-height: 40px;
        color: #fff;
        background-color: #ef3838;
        border-radius: 10px;
        margin-right: 10px;
        
    }
    #picbox .box .footer a:nth-child(2){
        background-color: #338831;
        margin-right: 0px;
    }
</style>
